import Heading2 from "../Basic/Heading2";
import React, { useEffect } from 'react';


const ProductImagesCreate = ({ productData, setProductData,imageItems, setImageItems }) => {
  useEffect(() => {
  return () => {
    productData.images.forEach(img => {
      if (img instanceof File) {
        URL.revokeObjectURL(img);
      }
    });
  };
}, [productData.images]);
  const canAddMoreImages = imageItems.length < 6;

  const getImageSrc = (img) => {
    if (!img) return "";

    // عکس بک‌اند
    if (typeof img === "object" && !(img instanceof File)) {
      return img.preview || img.file || "";
    }

    // عکس جدید
    if (img instanceof File) {
      return URL.createObjectURL(img);
    }

    return "";
  };

  const handleImageUpload = (e) => {
  const files = Array.from(e.target.files);

  if (imageItems.length + files.length > 6) {
    alert('حداکثر ۶ عکس مجاز است');
    return;
  }

  const newItems = files.map((file, index) => ({
    id: `new-${Date.now()}-${index}`,
    file,
    preview: URL.createObjectURL(file),
    order: imageItems.length + index,
    is_featured: false
  }));

  setImageItems(prev => [...prev, ...newItems]);
};

    const handleImageRemove = (imageToRemove) => {
    setImageItems(prevItems => {
      const newItems = prevItems.filter(img => img.id !== imageToRemove.id);

      // اگر عکسی که پاک شد شاخص بود، اولین عکس باقی‌مانده را شاخص کن
      if (imageToRemove.is_featured && newItems.length > 0) {
        newItems[0].is_featured = true;
      }
      return newItems;
    });
  };

  const setFeatured = (selectedImage) => {
    setImageItems(prevItems =>
      prevItems.map(img => ({
        ...img,
        // عکس انتخابی شاخص می‌شود، بقیه غیرشاخص
        is_featured: img.id === selectedImage.id
      }))
    );
  };

  return (
      <div className="space-y-6">
        <Heading2 text={'گالری تصاویر'}/>
        {/* پیش‌نمایش عکس‌ها */}
        {/*{productData.images.length > 0 && (*/}
        <div>
          <h3 className="text-sm mb-4">عکس‌های بارگذاری شده</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {imageItems.map((image, index) => (
                <div key={index} className="relative aspect-square border rounded-lg overflow-hidden">
                  <img
                      src={getImageSrc(image)}
                      alt={`Product ${index + 1}`}
                      className="w-full h-full object-cover"
                  />

                  {/* نشانگر عکس شاخص */}
                  <div className="absolute top-1 left-1">
                    {image.is_featured === true && (
                        <span className="bg-green-500 text-white text-xs px-1.5 py-0.5 rounded">
                           عکس شاخص
                          </span>
                    )}
                  </div>

                  {/* دکمه‌های کنترلی */}
                  <div className="absolute bottom-1 left-1 right-1 flex justify-between items-center">
                    <button
                        onClick={() => setFeatured(image)}
                        className={`bg-[#FCFCFC]/50 text-[#9E9E9E] hover:text-[#858585] hover:bg-[#DBDBDB] p-1 rounded-full transition-colors duration-200 ${
                            image.is_featured === true ? 'hidden' : ''
                        }`}
                        title="انتخاب عکس شاخص"
                    >
                      <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </button>
                    <button
                        onClick={() => handleImageRemove(image)}
                        className="bg-[#FCFCFC]/50 text-[#E53935] hover:text-[#CB1E1A] hover:bg-[#DBDBDB] p-1 rounded-full transition-colors duration-200"
                        title="پاک کردن"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>
                </div>
            ))}

            {canAddMoreImages && (
                <div className="relative aspect-square border rounded-lg overflow-hidden">
                  <div className="h-full border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                    <input
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="hidden"
                        id="image-upload"
                    />
                    <label
                        htmlFor="image-upload"
                        className="cursor-pointer bg-[#1E3A5F] text-[#FFC107] px-6 py-3 rounded-md hover:bg-[#2B5388] hover:text-[#D19D00] inline-block"
                      >
                        انتخاب عکس‌
                      </label>
                    </div>
                   </div>
                    )}

                </div>
                </div>
              {/*)}*/}
            <p className="text-sm text-gray-500 mt-2">
          {productData.images.length}/6 عکس - فرمت‌های مجاز: JPG, PNG, GIF
        </p>
      </div>

  );
};

export default ProductImagesCreate;